import React from 'react';
import { CustomOverlay as Overlay } from '@uiw/react-baidu-map'
import { Marker as AMarker } from '@uiw/react-amap';
import { MAP_TYPE, MAP_TYPES } from '@helpers/Constants';

interface MarkerOptionProps {
  position: {
    lng: number;
    lat: number
  };
  children?: any;
  offset?: number[];
  icon?: string;
  content?: React.ReactNode;
  type?: string;
  zIndex?: number;
  paneName?: string;
}

const dataAdapter = (type: string, data: MarkerOptionProps) => {
  let markerData = data;
  switch(type) {
    case MAP_TYPES.aMap:
      markerData = {
        ...markerData,
        position: [data.position?.lng, data.position.lat]
      } as any
      break;
    //no default;

  }
  return markerData
}

const CustomOverlay = (props: MarkerOptionProps) => {
  const content = {
    [MAP_TYPES.aMap]: AMarker,
    [MAP_TYPES.bMap]: Overlay
  }

  const Content = content[MAP_TYPE] || null;
  const data: any = dataAdapter(MAP_TYPE, props);
  if(Content) {
    return <Content {...data } />
  }
  return null
}

export default CustomOverlay;
